import { DateTime } from '@/modules/shared/schemas/DateTime'

import { TicketRepository } from '../repositories/TicketRepository'

export function ListPersonaTicketsCase(ticketRepository: TicketRepository) {
  return async function ({
    personaId,
    date
  }: {
    personaId: string
    date: DateTime
  }) {
    return await ticketRepository.listTicketsPersona({ personaId, date })
  }
}
